import React, { ReactNode } from "react";
import styled from "styled-components";

interface IBoxProps {
  bg?: string;
  pd?: string;
  mg?: string;
  br?: string;
  children: ReactNode;
}

const Box = (props: IBoxProps) => {
  return (
    <BoxSet bg={props.bg} pd={props.pd} mg={props.mg} br={props.br}>
      {props.children}
    </BoxSet>
  );
};

// Box
const BoxSet = styled.div<IBoxProps>`
  padding: ${(props) => props.pd || "15px"};
  margin: ${(props) => props.mg || "0"};
  ${(props) => props.bg && `background-color: ${props.bg};`}
  ${(props) => props.br && `border-radius: ${props.br};`}
`;

export default Box;
